import axios from "axios"
import { getBaseUrl } from "../utils/general_utils"


interface UserSignatureResponseData {
  user_id: string
  session_id: string
  signature: string
  epoch: number
  isLoggedIn: boolean
  token: string
}

export const healthStatus = async (): Promise<void> => {
  try {
    const healthUrl = `${getBaseUrl()}/help/chatbot/api/health/`

    const response = await axios.get(healthUrl, {
      headers: {
        "Content-Type": "application/json"
      },
      withCredentials: true
    })

    console.log("✅ Health status successful")
    console.log("Response:", response.data)
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || error.message || "Unknown error"
    console.warn("❌ Failed to get health status:", errorMsg)
    throw new Error(errorMsg)
  }
}


export const getUserSignature = async (
  sessionId: string): Promise<UserSignatureResponseData> => {
  try {
    const url = `${getBaseUrl()}/help/chatbot/api/chat/load/`
    const response = await axios.post(url, {
      session_id: sessionId ? sessionId : null
    },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        timeout: 5000 // 5 seconds timeout
      })

    if (response.data?.success) {
      process.env.GATSBY_DEBUG === "true" && console.log(response.data.message, response.data.data)
      return response.data.data
    } else {
      throw new Error(response.data?.message || "Failed to generate user signature")
    }
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || error.message || "Unknown error"
    console.error("❌ User signature verification failed:", errorMsg)
    throw new Error(errorMsg)
  }
}